var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a;
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import { getFullName, getInitials } from '@data/user/user';
import { useAddUserPermissions, useRemoveUserPermissions, useUserAssignedPermissions, useUsers, } from '@data/user/userActions';
import useFuseSearch from '@hooks/useFuseSearch';
import SearchInput from '@shared/input/SearchInput';
import List from '@shared/List';
import Modal from '@shared/modal/Modal';
import UserAvatar from '@shared/userprofile/Avatar';
import { TEBar, TEPermission, TEPermissionCheckBox } from '@styled/TagEditor';
import { appColors } from '@styled/useTheme';
import React, { useState } from 'react';
import { CellClassPermission, CELL_CLASS_PERMISSIONS_TITLE_MAP, ClusterClassPermission, SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP, DocumentClassPermission, DOCUMENT_CLASS_PERMISSIONS_TITLE_MAP, EntryLinkClassPermission, ENTRY_LINK_PERMISSIONS_TITLE_MAP, FeaturePermission, FEATURE_PERMISSIONS_TITLE_MAP, TagClassPermission, TAG_CLASS_PERMISSIONS_TITLE_MAP, UserClassPermission, USER_CLASS_PERMISSIONS_TITLE_MAP, } from '../../../../data/permission/permission';
import { getInitial } from '../../../../data/userGroup/userGroup';
import { useAddRolePermissions, useRemoveRolePermissions, useGroupAssignedPermissions, useUserGroups, } from '../../../../data/userGroup/userGroupActions';
import ModalHeader from '../../../../shared/modal/ModalHeader';
import { Loading } from '../../../../styled/Basic';
import { FormCheckBox, FormField } from '../../../../styled/Form';
import { ModalBody } from '../../../../styled/Modal';
import { Avatar, ListItem, MenuOption, TESearchBar, UserFullName } from '../../../../styled/Permissions';
import BorderdContainer from '../BorderedContainer';
import PermissionManagerLayout from '../PermissionManagerLayout';
var FUSE_CONFIG = {
    keys: [{ name: 'title', weight: 1 }],
    threshold: 0.25,
    minMatchCharLength: 2,
    useExtendedSearch: true,
};
var SUPER_USER_DISABLED_DEFAULT = (_a = {},
    _a[FeaturePermission.USERS_GROUPS_MANAGEMENT] = true,
    _a[FeaturePermission.ADMINISTRATION_MENU] = true,
    _a);
var defaultUserPermissions = [
    { name: 'FEATURE.TAGS_IN_MODEL', targetId: null },
    { name: 'FEATURE.TAGS_IN_NAVBAR', targetId: null },
    { name: 'FEATURE.TAGS_SIDEBAR', targetId: null },
    { name: 'FEATURE.CLUSTER_FLOW_ADD', targetId: null },
];
var defaultRolePermissions = [
    { name: 'FEATURE.TAGS_IN_MODEL', targetId: null },
    { name: 'FEATURE.TAGS_IN_NAVBAR', targetId: null },
    { name: 'FEATURE.TAGS_SIDEBAR', targetId: null },
    { name: 'FEATURE.CLUSTER_FLOW_ADD', targetId: null },
    { name: 'CLASS.TAG.FIND_ALL', targetId: null },
    { name: 'CLASS.TAG.GET_BY_ID', targetId: null },
    { name: 'CLASS.SHEET_ROW.FIND_ALL', targetId: null },
    { name: 'CLASS.SHEET_ROW.GET_BY_ID', targetId: null },
    { name: 'CLASS.DOCUMENT.FIND_ALL', targetId: null },
    { name: 'CLASS.DOCUMENT.GET_BY_ID', targetId: null },
];
function Content(_a) {
    var item = _a.item, isSelected = _a.isSelected;
    return (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        React.createElement(Avatar, null,
            React.createElement(UserAvatar, { initials: item.initials, backgroundColor: isSelected ? appColors.primary.w500 : appColors.neutral.w100, color: isSelected ? appColors.ui.white : appColors.ui.dark })),
        React.createElement(UserFullName, { "$color": isSelected ? appColors.primary.w500 : 'black' }, isSelected ? React.createElement("b", null, item.title) : item.title)));
}
function UsersRolesTab(_a) {
    var items = _a.items, onSelectHandler = _a.onSelectHandler, searchString = _a.searchString, searchChangeHandler = _a.searchChangeHandler, _b = _a.state, selectedId = _b.selectedId, selectedMenu = _b.selectedMenu;
    var L = useLanguage().L;
    function Item(_a) {
        var item = _a.item, isSelected = _a.isSelected;
        return React.createElement(Content, { item: item, isSelected: isSelected });
    }
    function renderItem(item) {
        return (React.createElement(ListItem, { "$isSelected": item.id === selectedId, key: item.id, onClick: function () { return onSelectHandler(item.id); } },
            React.createElement(Item, { item: item, isSelected: item.id === selectedId })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(BorderdContainer, null,
            React.createElement(SearchInput, { css: { margin: '15px', flexGrow: 0 }, name: selectedMenu, placeholder: selectedMenu == 'users' ? L('Search for users...') : L('Search for groups...'), value: searchString, onChange: searchChangeHandler }),
            React.createElement(List, { gap: 0, items: items, renderItem: renderItem, style: {
                    paddingLeft: 15,
                    paddingBottom: 15,
                    overflowY: 'scroll',
                    overflowX: 'auto',
                } }))));
}
function userToListItem(user) {
    return {
        id: user.id,
        title: user.keycloakId ? getFullName(user) : user.firstName,
        style: null,
        initials: getInitials(user),
        type: 'users',
    };
}
function userGroupToListItem(role) {
    return {
        id: role.id,
        title: role.name,
        style: null,
        initials: getInitial(role),
        type: 'groups',
    };
}
function PermissionsTab(_a) {
    var _b = _a.superUser, superUser = _b === void 0 ? false : _b, assignedPermissions = _a.assignedPermissions, onChange = _a.onChange, defaultButtonClickHandler = _a.defaultButtonClickHandler, clearAllButtonClickHandler = _a.clearAllButtonClickHandler, selectedMenu = _a.selectedMenu, operationPending = _a.operationPending;
    var featurePermissions = Object.values(FeaturePermission);
    var isPermissionAssigned = function (permission) {
        return assignedPermissions.find(function (p) { return p.name === permission.name; }) !== undefined;
    };
    function getSearchablePermissions() {
        var e_1, _a;
        var permissions = [];
        try {
            for (var _b = __values(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(featurePermissions), false), __read(Object.values(TagClassPermission)), false), __read(Object.values(ClusterClassPermission)), false), __read(Object.values(DocumentClassPermission)), false), __read(Object.values(CellClassPermission)), false), __read(Object.values(UserClassPermission)), false)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var value = _c.value;
                var title = value;
                var name = value;
                permissions.push({ title: title, name: name, targetId: null });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return permissions;
    }
    var L = useLanguage().L;
    var permissions = getSearchablePermissions();
    var _c = useFuseSearch(permissions, FUSE_CONFIG), resultSet = _c.resultSet, searchString = _c.searchString, searchChangeHandler = _c.searchChangeHandler;
    function renderPermission(enumValue, permissionTitleMap) {
        var text = L(permissionTitleMap[enumValue]);
        var value = enumValue;
        var permission = { name: value, targetId: null };
        var isDisabled = ((featurePermissions.includes(value) && !!SUPER_USER_DISABLED_DEFAULT[value]) ||
            !featurePermissions.includes(value)) &&
            superUser;
        if (resultSet === undefined || (resultSet === null || resultSet === void 0 ? void 0 : resultSet.find(function (x) { return x.title === L(value); })) !== undefined) {
            return (React.createElement(FormCheckBox, { key: value },
                React.createElement("input", { id: value, type: "checkbox", style: { marginRight: 10, cursor: 'pointer' }, value: value, checked: isDisabled || isPermissionAssigned(permission), onChange: onChange, disabled: isDisabled }),
                React.createElement("label", { style: { cursor: 'pointer' }, htmlFor: value }, text)));
        }
        else {
            return React.createElement("div", { style: { display: 'none' }, key: value });
        }
    }
    var featurePermissionsCheckboxes = Object.values(FeaturePermission).map(function (p) {
        return renderPermission(p, FEATURE_PERMISSIONS_TITLE_MAP);
    });
    var classPermissionsCheckboxes = Object.values(TagClassPermission).map(function (p) {
        return renderPermission(p, TAG_CLASS_PERMISSIONS_TITLE_MAP);
    });
    classPermissionsCheckboxes = classPermissionsCheckboxes.concat(Object.values(ClusterClassPermission).map(function (p) {
        return renderPermission(p, SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP);
    }));
    classPermissionsCheckboxes = classPermissionsCheckboxes.concat(Object.values(DocumentClassPermission).map(function (p) {
        return renderPermission(p, DOCUMENT_CLASS_PERMISSIONS_TITLE_MAP);
    }));
    classPermissionsCheckboxes = classPermissionsCheckboxes.concat(Object.values(UserClassPermission).map(function (p) {
        return renderPermission(p, USER_CLASS_PERMISSIONS_TITLE_MAP);
    }));
    classPermissionsCheckboxes = classPermissionsCheckboxes.concat(Object.values(CellClassPermission).map(function (p) {
        return renderPermission(p, CELL_CLASS_PERMISSIONS_TITLE_MAP);
    }));
    classPermissionsCheckboxes = classPermissionsCheckboxes.concat(Object.values(EntryLinkClassPermission).map(function (p) {
        return renderPermission(p, ENTRY_LINK_PERMISSIONS_TITLE_MAP);
    }));
    return (React.createElement(React.Fragment, null,
        React.createElement(BorderdContainer, null,
            React.createElement(TESearchBar, null,
                React.createElement(SearchInput, { css: { margin: '15px', flexGrow: 1, width: '20%' }, name: "permissions", placeholder: L('Search for permissions...'), value: searchString, onChange: searchChangeHandler }),
                React.createElement(FSButton, { "$type": "tertiary", title: L('Default'), onClick: defaultButtonClickHandler }),
                React.createElement(FSButton, { "$type": "tertiary", title: L('Clear all'), onClick: clearAllButtonClickHandler })),
            operationPending ? (React.createElement("div", { style: { display: 'grid', placeItems: 'center', flexGrow: 1 } },
                React.createElement(Loading, { "$color": "neutral", "$size": 20, style: {
                        width: '20px',
                        height: '20px',
                    } }))) : (React.createElement("div", { style: { overflowY: 'scroll', overflowX: 'auto' } },
                featurePermissionsCheckboxes.some(function (e) { return e.type === FormCheckBox; }) ? (React.createElement(FormField, { "$bottomSpace": true, style: { paddingRight: 15, paddingLeft: 15, paddingBottom: 15 } },
                    React.createElement(TEPermission, null,
                        React.createElement("b", null, L('FEATURE PERMISSIONS'))),
                    React.createElement(TEPermissionCheckBox, null, featurePermissionsCheckboxes))) : (React.createElement(React.Fragment, null)),
                classPermissionsCheckboxes.some(function (e) { return e.type === FormCheckBox; }) ? (React.createElement(FormField, { "$bottomSpace": true, style: { paddingRight: 15, paddingLeft: 15, paddingBottom: 15 } },
                    React.createElement(TEPermission, null,
                        React.createElement("b", null, L('CLASS PERMISSIONS'))),
                    React.createElement(TEPermissionCheckBox, null, classPermissionsCheckboxes))) : (React.createElement(React.Fragment, null)))))));
}
function PermissionsModal() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var L = useLanguage().L;
    var users = useUsers();
    var userItems = (_b = (_a = users.data) === null || _a === void 0 ? void 0 : _a.map(userToListItem)) !== null && _b !== void 0 ? _b : [];
    var _m = __read(useState((_c = userItems[0]) === null || _c === void 0 ? void 0 : _c.id), 2), selectedUserId = _m[0], setSelectedUserId = _m[1];
    var roles = useUserGroups();
    var roleItems = (_e = (_d = roles.data) === null || _d === void 0 ? void 0 : _d.map(userGroupToListItem)) !== null && _e !== void 0 ? _e : [];
    var _o = __read(useState((_f = roleItems[0]) === null || _f === void 0 ? void 0 : _f.id), 2), selectedRoleId = _o[0], setSelectedRoleId = _o[1];
    var _p = __read(useState('users'), 2), selectedMenu = _p[0], setSelectedMenu = _p[1];
    var userPermissions = useUserAssignedPermissions(selectedUserId);
    var rolePermissions = useGroupAssignedPermissions(selectedRoleId);
    var addUserPermissionsMutation = useAddUserPermissions();
    var removeUserPermissionsMutation = useRemoveUserPermissions();
    var addRolePermissionsMutation = useAddRolePermissions();
    var removeRolePermissionsMutation = useRemoveRolePermissions();
    var userPermissionsData = userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.data;
    var rolePermissionsData = rolePermissions === null || rolePermissions === void 0 ? void 0 : rolePermissions.data;
    function getSelectedPermissions() {
        var _a;
        return (_a = (selectedUserId !== undefined ? userPermissionsData : rolePermissionsData)) !== null && _a !== void 0 ? _a : [];
    }
    var selectedPermissions = getSelectedPermissions();
    function addUserPermissionHandler(permission) {
        if (selectedUserId !== undefined) {
            addUserPermissionsMutation.mutate({ id: selectedUserId, permissions: [permission] });
        }
    }
    function removeUserPermissionHandler(permission) {
        if (selectedUserId !== undefined) {
            removeUserPermissionsMutation.mutate({ id: selectedUserId, permissions: [permission] });
        }
    }
    function removeUserPermissionsHandler(permissions) {
        if (selectedUserId !== undefined) {
            removeUserPermissionsMutation.mutate({ id: selectedUserId, permissions: permissions });
        }
    }
    function addRolePermissionHandler(permission) {
        if (selectedRoleId !== undefined) {
            addRolePermissionsMutation.mutate({ id: selectedRoleId, permissions: [permission] });
        }
    }
    function removeRolePermissionHandler(permission) {
        if (selectedRoleId !== undefined) {
            removeRolePermissionsMutation.mutate({ id: selectedRoleId, permissions: [permission] });
        }
    }
    function removeRolePermissionsHandler(permissions) {
        if (selectedRoleId !== undefined) {
            removeRolePermissionsMutation.mutate({ id: selectedRoleId, permissions: permissions });
        }
    }
    function selectUserHandler(id) {
        setSelectedUserId(id);
        setSelectedRoleId(undefined);
    }
    function selectRoleHandler(id) {
        setSelectedRoleId(id);
        setSelectedUserId(undefined);
    }
    var onChange = function (event) {
        var value = event.target.value;
        var permission = { name: value, targetId: null };
        var changedPermission = selectedPermissions.find(function (p) { return p.name === permission.name; });
        if (event.target.disabled) {
            return;
        }
        if (changedPermission !== undefined) {
            if (selectedUserId !== undefined) {
                removeUserPermissionHandler(permission);
            }
            else if (selectedRoleId !== undefined) {
                removeRolePermissionHandler(permission);
            }
        }
        else {
            if (selectedUserId !== undefined) {
                addUserPermissionHandler(permission);
            }
            else if (selectedRoleId !== undefined) {
                addRolePermissionHandler(permission);
            }
        }
    };
    function defaultButtonClickHandler() {
        if (selectedUserId !== undefined && selectedMenu === 'users') {
            var permissionsToRemove = selectedPermissions.filter(function (x) { return !defaultUserPermissions.some(function (y) { return y.name === x.name; }); });
            removeUserPermissionsMutation.mutate({ id: selectedUserId, permissions: permissionsToRemove }, {
                onSuccess: function () {
                    addUserPermissionsMutation.mutate({ id: selectedUserId, permissions: defaultUserPermissions });
                },
            });
        }
        else if (selectedRoleId !== undefined) {
            var permissionsToRemove = selectedPermissions.filter(function (x) { return !defaultRolePermissions.some(function (y) { return y.name === x.name; }); });
            removeRolePermissionsMutation.mutate({ id: selectedRoleId, permissions: permissionsToRemove }, {
                onSuccess: function () {
                    addRolePermissionsMutation.mutate({ id: selectedRoleId, permissions: defaultRolePermissions });
                },
            });
        }
    }
    function clearAllButtonClickHandler() {
        if (selectedUserId !== undefined) {
            removeUserPermissionsHandler(selectedPermissions);
        }
        else if (selectedRoleId !== undefined) {
            removeRolePermissionsHandler(selectedPermissions);
        }
    }
    var superUser = selectedMenu === 'users'
        ? (_h = (_g = users.data) === null || _g === void 0 ? void 0 : _g.find(function (u) { return u.id === selectedUserId; })) === null || _h === void 0 ? void 0 : _h.isSuperUser
        : (_k = (_j = roles.data) === null || _j === void 0 ? void 0 : _j.find(function (r) { return r.id === selectedRoleId; })) === null || _k === void 0 ? void 0 : _k.areSuperUsers;
    var fuseItems = selectedMenu == 'users' ? userItems : roleItems;
    var _q = useFuseSearch(fuseItems, FUSE_CONFIG), resultSet = _q.resultSet, searchString = _q.searchString, setSearchString = _q.setSearchString, searchChangeHandler = _q.searchChangeHandler;
    var items = resultSet !== undefined && ((_l = resultSet[0]) === null || _l === void 0 ? void 0 : _l.type) === selectedMenu
        ? resultSet
        : selectedMenu === 'users'
            ? userItems
            : roleItems;
    var contentLeft = (React.createElement(UsersRolesTab, { items: items, onSelectHandler: selectedMenu === 'users' ? selectUserHandler : selectRoleHandler, searchString: searchString, searchChangeHandler: searchChangeHandler, state: { selectedId: selectedMenu === 'users' ? selectedUserId : selectedRoleId, selectedMenu: selectedMenu } }));
    var contentRight = (React.createElement(PermissionsTab, { superUser: superUser, assignedPermissions: selectedPermissions, onChange: onChange, defaultButtonClickHandler: defaultButtonClickHandler, clearAllButtonClickHandler: clearAllButtonClickHandler, selectedMenu: selectedMenu, operationPending: selectedUserId !== undefined
            ? (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.status) !== 'success'
            : (rolePermissions === null || rolePermissions === void 0 ? void 0 : rolePermissions.status) !== 'success' }));
    return (React.createElement(Modal, { width: 1000 },
        React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
            } },
            React.createElement(ModalHeader, { title: L('Permissions') }),
            React.createElement(ModalBody, null,
                React.createElement(TEBar, null,
                    React.createElement(MenuOption, { onClick: function () {
                            setSelectedMenu('users');
                            setSelectedUserId(userItems[0].id);
                            setSelectedRoleId(undefined);
                            setSearchString('');
                        }, "$isSelected": selectedMenu === 'users' }, selectedMenu === 'users' ? React.createElement("b", null, L('Users')) : L('Users')),
                    React.createElement(MenuOption, { onClick: function () {
                            setSelectedMenu('groups');
                            setSelectedRoleId(roleItems[0].id);
                            setSelectedUserId(undefined);
                            setSearchString('');
                        }, "$isSelected": selectedMenu === 'groups' }, selectedMenu === 'groups' ? React.createElement("b", null, L('Groups')) : L('Groups'))),
                React.createElement(PermissionManagerLayout, { contentLeft: contentLeft, contentRight: contentRight })))));
}
export default PermissionsModal;
